export default {
  SET_LOADING(state, status) {
    state.loading = status;
  },

  SET_WEBSITES(state, websites) {
    state.websites = websites;
  },

  SET_SELECTED_WEBSITE(state, website) {
    state.selectedWebsite = website;
  },

  SET_SELECTED_LOCATION(state, location) {
    state.selectedLocation = location;
  },

  SET_LOCATION_KEYWORDS(state, locationKeywords) {
    state.selectedLocationKeywords = locationKeywords;
  },

  SET_FETCHED_LOCATION_KEYWORDS(state, { id, keywords }) {
    state.fetchedLocationKeywords[id] = keywords;
  },

  SET_FETCHED_KEYWORD_DATA(state, { id, keywordData }) {
    state.fetchedKeywordData[id] = keywordData;
  },

  SET_SELECTED_KEYWORD_DATA(state, keywordData) {
    state.selectedKeywordData = keywordData;
  },

  SET_CURRENT_MONTH(state, month) {
    state.currentMonth = month;
  },

  DELETE_FROM_WEBSITES(state, newWebsites) {
    state.websites = newWebsites;
  }
};
